interface Props {
  className?: string;
}

export default function Guest({ className }: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 11c-5.6 0-6.667 5.333-6.5 8h13c.167-2.667-.9-8-6.5-8zM8.5 1a3.5 3.5 0 110 7 3.5 3.5 0 010-7z"
        stroke="currentColor"
        strokeWidth={2}
      />
      <path
        d="M13.821 13.788c.721-.908 1.834-1.566 3.505-1.566 4.044 0 4.815 3.852 4.694 5.778H15M17.528 4a2.528 2.528 0 110 5.056 2.528 2.528 0 010-5.056z"
        stroke="currentColor"
        strokeWidth={2}
      />
    </svg>
  );
}
